import { SaasTierType } from 'src/models/organizations.models'
import { UserFeature, userFeatureRequiredTier } from 'src/models/user.models'
import { useQueryUserFeatures } from 'src/queries/auth.queries'

interface UseHasSaasEntitlementProps {
  feature?: UserFeature
}

interface UseHaasSaasEntitlementReturn {
  upgradeRequired: boolean
  loading: boolean
  requiredTier?: SaasTierType
}

export const useHasSaasEntitlement = ({
  feature,
}: UseHasSaasEntitlementProps): UseHaasSaasEntitlementReturn => {
  const { data: featuresData, isLoading: featuresLoading } =
    useQueryUserFeatures(
      feature
        ? [UserFeature.SAAS_ENABLED, feature]
        : [UserFeature.SAAS_ENABLED],
      {
        enabled: feature !== undefined,
      },
    )

  if (!feature) {
    return { upgradeRequired: false, loading: false }
  }
  // If SAAS_ENABLED is false, no upgrade is required
  if (!featuresData?.[UserFeature.SAAS_ENABLED]) {
    return { upgradeRequired: false, loading: featuresLoading }
  }

  const upgradeRequired = !featuresLoading && !featuresData?.[feature]
  // If the feature is enabled, no upgrade is required
  return {
    upgradeRequired,
    requiredTier: userFeatureRequiredTier(feature),
    loading: featuresLoading,
  }
}
